const BUSINESS_ROLES = {
    director: 'Director',
    owner: 'Owner',
    other: 'Other'
};

export default BUSINESS_ROLES;
